export const PROD_CODES = {
  SALPL: {
    types: new Set<string>([
      "SAL_NO_OFFER",
      "SAL_GIN",
      "SAL_PREAPPROVED",
      "RSL_LINE",
      "RSL_NO_OFFER",
      "RSL_PREAPPROVED",
    ]),
    value: "SALPL",
  },
  PLCS: {
    types: new Set<string>([
      "PLCS_GIN",
      "PLCS_NORMAL",
      "RPL_FULL_UW",
      "RPL_LITE_UW",
      "RPL_STP",
      "RPPL_FUW",
      "PPL_PREQUALIFIED",
      "PLCS_PREQUALIFIED",
      "PLPPL_PREQUALIFIED",
      "PLCS_3PL",
    ]),
    value: "PLCS",
  },
  TWL: {
    types: new Set<string>(["TW_NTB", "TW_PTB", "TW_ETB"]),
    value: "TWL",
  },
  UTL_ALL: {
    types: new Set<string>(["UTL_ALL"]),
    value: "UTL_ALL",
  },
  UTL_LAT: {
    types: new Set<string>(["UTL_LAT"]),
    value: "UTL_LAT",
  },
  UTL_BT: {
    types: new Set<string>(["UTL_BT"]),
    value: "UTL_BT",
  },
  EMI: {
    types: new Set<string>(["EMI", "EMI-VC", "EMI-AC", "EMIPWA"]),
    value: "EMI",
  },
  HC: {
    types: new Set<string>(["EMI-HC"]),
    value: "HC",
  },
  DL: {
    types: new Set<string>([
      "PRO_GCO_DL",
      "PRO_NTB_DL",
      "PRO_ETB_DL",
      "RPR_NTB_DL",
      "PRO_DL",
      "PRO_ICL_DL",
      "RPR_TOPUP",
    ]),
    value: "DL",
  },
  DC: {
    types: new Set<string>(["LAPPROF_DC_NTB_DL"]),
    value: "DC",
  },
  PEMFR: {
    types: new Set<string>(["PEMFR_NTB"]),
    value: "PEMFR",
  },
  LFL: {
    types: new Set<string>(["PRO_LW", "PRO_NTB_LW", "PRO_ETB_LW"]),
    value: "LFL",
  },
  BL: {
    types: new Set<string>([
      "PRO_BL_NTB",
      "PSBL_NTB",
      "PSBL_OFFER",
      "PSBL",
      "PLBL_SLV",
      "PSBL_ICL",
    ]),
    value: "BL",
  },
  PHARMA: {
    types: new Set<string>(["RPR_NTB_PHARMA"]),
    value: "PHARMA",
  },
  CA: {
    types: new Set<string>(["PRO_GCO_CA", "PRO_NTB_CA", "PRO_ETB_CA", "PRO_ICL_CA"]),
    value: "CA",
  },
  FD: {
    types: new Set<string>([
      "FD",
      "HUFETBLTS",
      "HUFETBHTS",
      "HUFNTBLTS",
      "HUFNTBHTS",
      "FDNTBLTS",
      "FDNTBHTS",
      "FDETBLTS",
      "FDETBHTS",
      "SPNTBLTS",
      "SPNTBHTS",
      "SPETBLTS",
      "SPETBHTS",
      "EXPRESSFDHTS",
      "EXPRESSFDLTS",
      "MINORNTBLTS",
      "MINORNTBHTS",
      "MINORETBLTS",
      "MINORETBHTS",
    ]),
    value: "FD",
  },
  SDP: {
    types: new Set<string>(["SDP"]),
    value: "SDP",
  },
  LAP: {
    types: new Set<string>([
      "SMELAP_ETB",
      "SMELAP_NTB",
      "SMELAP_OFFER",
      "LAPPROF_OFFER",
      "LAPPROF_ETB",
      "LAPPROF_NTB",
      "SMELAP_NTB_FRESH",
      "SMELAP_OFFER_FRESH",
      "LAPPROF_NTB_FRESH",
      "LAPPROF_OFFER_FRESH",
    ]),
    value: "LAP",
  },
  LAPBT: {
    types: new Set<string>([
      "SMELAP_NTB_BT",
      "SMELAP_OFFER_BT",
      "LAPPROF_NTB_BT",
      "LAPPROF_OFFER_BT",
    ]),
    value: "LAPBT",
  },
  GLFRESH: {
    types: new Set<string>(["GLFRESH"]),
    value: "GLFRESH",
  },
  GLBT: {
    types: new Set<string>(["GLBT"]),
    value: "GLBT",
  },
  LAS_SHARES: {
    types: new Set<string>(["LAS_SHARES", "HTS_LAS"]),
    value: "LAS",
  },
  LAS_MUTUALFUND: {
    types: new Set<string>(["LAS_MUTUALFUND", "HTS_LAMF"]),
    value: "LAS",
  },
  HL: {
    types: new Set<string>(["HL", "HL_NO_OFFER", "HL_FRESH", "HL_OFFER"]),
    value: "HL",
  },
  HL_BT: {
    types: new Set<string>(["HL_BT_NO_OFFER", "HL_BT_OFFER", "HL_BT"]),
    value: "HLBT",
  },
  BLSE: {
    types: new Set<string>([
      "BLSE_OFFER",
      "BLSE_NTB",
      "PLSE_NTB",
      "PLSE_OFFER",
      "MBLS_NTB",
      "MBLS_OFFER",
    ]),
    value: "BLSE",
  },
  BLSEBT: {
    types: new Set<string>([
      "BLSE_OFFER_BT",
      "BLSE_NTB_BT",
      "PLSE_NTB_BT",
      "PLSE_OFFER_BT",
      "MBLS_NTB_BT",
      "MBLS_OFFER_BT",
    ]),
    value: "BLSEBT",
  },
  UCF_SP: {
    types: new Set<string>(["ZCUC", "ZCUC_NTB", "ZCUC_OFFER"]),
    value: "UCF_SP",
  },
  UCF_LAC: {
    types: new Set<string>(["ZLC", "ZLC_OFFER", "ZLC_NTB"]),
    value: "UCF_LAC",
  },
  UCF_ALBT: {
    types: new Set<string>(["ZBT", "ZBT_OFFER", "ZBT_NTB"]),
    value: "UCF_ALBT",
  },
  LAIP: {
    types: new Set<string>(["HTS_LAIP"]),
    value: "LAIP",
  },
  CC: {
    types: new Set<string>(["CC_RBL", "CC_DBS"]),
    value: "CC",
  },
  PLCARD: {
    types: new Set<string>(["PLCARD"]),
    value: "PLCARD",
  },
  BEMFR: {
    types: new Set<string>(["BEMFR", "BEMFR_NTB"]),
    value: "BEMFR",
  },
  MICRO_FINANCE: {
    types: new Set<string>(["MICRO_FINANCE"]),
    value: "MICRO_FINANCE",
  },
  AASTANDA: {
    types: new Set<string>(["AASTANDA"]),
    value: "AASTANDA",
  },
  BALIC: {
    types: new Set<string>(["BALIC"]),
    value: "BALIC",
  },
  NCL: {
    types: new Set<string>(["NCL_PTB", "NCL_NTB", "NCL_ETB"]),
    value: "NCL",
    PAS_EVENTS: new Set<string>([]),
  },
  NTL_ALL: {
    types: new Set<string>(["NTL_ALL"]),
    value: "NTL_ALL",
  },
} as const;

export const CART_CONSTANTS = {
  WEB: "web",
  ALL: "all",
  CMS_CART_RES: "cmsCartRes",
  CMS_LAST_REFRESH: "cmsCartResLastRefresh",
  CHANNEL: "3in1",
} as const;

// usefull to differentiate cart insert pdp or webfrom insert
export const PDP_INSERT_EVENTCODE = [
  "B2C_PDP",
  "HL_PDP",
  "SME_OFFER",
  "SME_PSBL",
  "SME_BLSE",
  "LAP_PDP",
];

export const PDP_INSERT_EVENTCODE_FROM_RESUME_POP_DELETION = ["SME_BLSE", "LAP_PDP"];

export type TypeCartProduct = keyof typeof PROD_CODES;

export const DEFAULT_BALIC_CART_AMOUNT = "10000000";
